import { gql } from '@apollo/client'
import { PICOS_PRIORITY_FRAGMENT } from '../fragments'

export const CREATE_PICOS_PRIORITY = gql`
  mutation CreatePicosPriority($input: CreatePicOSPriorityInput!) {
    createPicosPriority(input: $input) {
      picosPriority {
        ...PicOSPriority
      }
    }
  }
  ${PICOS_PRIORITY_FRAGMENT}
`
